import { render, staticRenderFns } from "./LocalVideo.vue?vue&type=template&id=2afb7932&scoped=true"
import script from "./LocalVideo.vue?vue&type=script&lang=js"
export * from "./LocalVideo.vue?vue&type=script&lang=js"
import style0 from "./LocalVideo.vue?vue&type=style&index=0&id=2afb7932&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.41_cache-loader@4.1.0_webpack@4.47.0__css-load_17791d15a6e6b4923732070da1170b91/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2afb7932",
  null
  
)

export default component.exports